
angular.module('aprima-core-ui').directive('multiCheckbox', function() {
    'use strict';
    return {

        restrict: 'EA',

        templateUrl: '/core-ui/views/directives/multiSelectCheckBox.html',

        replace: true,

        transclude: false,

        scope: {

            selectedlist: '=',

            sourcelist: '=',

            all: '=',

            sortBy: '='

        },

        link: function ($scope) {

            $scope.checkbox = {};

            $scope.selectAll = false; //set 'All' checkbox to false

            $scope.showAll = $scope.all === true ? true : false;//to show/hide 'All' checkbox

            $scope.list = $scope.sourcelist;

            //add selected property
            $scope.list = _.forEach($scope.list, function(item){
                _.assign(item,{selected : false, formattedDate : item.Date.format('YYYY-MM-DD')});
            });

            $scope.list = _.orderBy($scope.list, $scope.sortBy, 'desc');

            $scope.selection = [];

            $scope.$watch('selectAll', function (newVal,oldVal) {
                if(newVal !== oldVal){
                    $scope.list = _.forEach($scope.list, function(item){
                        item.selected = $scope.selectAll;
                    });
                }
            }, true);

            $scope.$watchCollection('list|filter:{selected:true}', function (newVal,oldVal) {
                if(newVal !== oldVal){
                    $scope.selectedlist = newVal;
                }
            });

        }

    };
});
